import React, {useState} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import {makeStyles} from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

import {reset} from '../services/api'
import {IResetRequestParams} from '../interfaces/api'
import {Alert} from '@material-ui/lab'
import queryString from 'querystring'

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import BootstrapButton from './Common/BootstrapButton'
import BootstrapInput from './Common/BootstrapInput'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.dark,
    },
    paper: {
        height: '100vh',
        paddingTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))

export default function ResetPassword() {
    const classes = useStyles()
    const history = useHistory()

    const {search} = useLocation()
    const {token} = queryString.parse(search.substring(1))

    console.log(token)
    const handleLoggedIn = () => {
        history.push('/signin')
    }

    const [error, setError] = useState<string[]>([])
    const [message, setMessage] = useState<string[]>([])
    const [userInfo, setUserInfo] = useState<IResetRequestParams>({
        newPassword: '',
        newPasswordConfirmation: '',
        token: token,
    })

    const handleSubmit = async () => {
        setError([])

        const response = await reset(userInfo)

        if (response.data.errors) {
            if (response.data.errors.length > 0) {
                setError(
                    response.data.errors.map((item: any, idx: number) => {
                        return <span key={idx}>{item.message}</span>
                    })
                )
            } else {
                //we only have main error
                setError(response.data.message)
            }
            console.info(response.data.errors)
            return
        } else {
            setMessage(response.data.message)
        }
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.root}>
            <CssBaseline/>
            <div className={classes.paper}>

                <form className={classes.form} noValidate>
                    <Typography align="center">
                        Please enter your new password.
                    </Typography>
                    <Grid item xs={12}>
                        {error && error.length ? (
                            <Alert severity="error">{error}</Alert>
                        ) : (
                            ''
                        )}
                        {message && message.length ? (
                            <Alert severity="success">{message} &nbsp;<Link href="/signin">
                                Click here
                            </Link></Alert>
                        ) : (
                            ''
                        )}
                    </Grid>
                    <br/>
                    {message && message.length ? null : <FormControl fullWidth>
                        <InputLabel style={{color: '#000'}} shrink htmlFor="bootstrap-input">
                            New Password
                        </InputLabel>
                        <BootstrapInput
                            name="newPassword"
                            type="password"
                            id="bootstrap-input"
                            value={userInfo.newPassword}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setUserInfo({
                                    ...userInfo,
                                    newPassword: e.currentTarget.value,
                                })
                            }/>
                    </FormControl>}
                    <br/>
                    <br/>
                    {message && message.length ? null : <FormControl fullWidth>
                        <InputLabel style={{color: '#000'}} shrink htmlFor="bootstrap-input">
                            New Password Confirmation
                        </InputLabel>
                        <BootstrapInput
                            name="newPasswordConfirmation"
                            type="password"
                            id="bootstrap-input"
                            value={userInfo.newPasswordConfirmation}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setUserInfo({
                                    ...userInfo,
                                    newPasswordConfirmation: e.currentTarget.value,
                                })
                            }/>
                    </FormControl>}
                    <br/>
                    {message && message.length ? null :
                        <div style={{textAlign: "center", bottom: 0, margin: "20px 0px"}}>
                            <BootstrapButton
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={handleSubmit}>
                                Reset
                            </BootstrapButton>
                        </div>}
                </form>
            </div>
        </Container>
    )
}
